import * as React from "react";
import Box from "@mui/material/Box";
import messenger from "../../../../assets/messanger.png";
import { useRef } from "react";

export default function SpeedDialComponent() {
  const speedDialBox = useRef();
  const navigateToMessenger = () => {
    const anchor = document.createElement("a");
    anchor.setAttribute("href", "http://m.me/Speedyourweb");
    anchor.setAttribute("id", "messangerLink");
    anchor.setAttribute("target", "_blank");
    speedDialBox.current.append(anchor);
    console.log(anchor, speedDialBox.current);
    anchor.click();
    anchor.remove();
  };
  return (
    <Box ref={speedDialBox}>
      <Box
        sx={{
          position: "fixed",
          bottom: 16,
          right: 16,
          width: "56px",
          height: "56px",
          borderRadius: "50%",
          background: "rgba(256, 256, 256, 1)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          boxShadow:
            "rgb(0 0 0 / 20%) 0px 3px 5px -1px, rgb(0 0 0 / 14%) 0px 6px 10px 0px, rgb(0 0 0 / 12%) 0px 1px 18px 0px;",
          cursor: "pointer",
          "&:hover": {
            background: "#1565c0",
          },
        }}
        onClick={navigateToMessenger}
      >
        <img src={messenger} width="90px" alt="messenger" />
      </Box>
    </Box>
  );
}
